import { render, staticRenderFns } from "./SSOSettings.vue?vue&type=template&id=9ac3020c&scoped=true"
import script from "./SSOSettings.vue?vue&type=script&lang=js"
export * from "./SSOSettings.vue?vue&type=script&lang=js"
import style0 from "./SSOSettings.vue?vue&type=style&index=0&id=9ac3020c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac3020c",
  null
  
)

export default component.exports